module.exports = __webpack_public_path__ + "static/media/arrow-right-grey.8c604f45.svg";